<template>
  <li class="wt-context-menu-item">
    <slot />
  </li>
</template>

<script>
export default {};
</script>
